import React, { useEffect } from "react";
import { NotificationManager } from "react-notifications";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import Modal from "react-responsive-modal";
import { CreacionTrasladoAlmacenApi } from "../api/CreacionTrasladoAlmacenApi";
import { Controller, useForm } from "react-hook-form";
import DatePicker from "react-datepicker";
import {
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../utility/utils";
import moment from "moment";
import { DatosAlmacen } from "./DatosAlmacen";
import NullableValue from "../../../../../Utils/renderField/nullableValue";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../Utils/renderField/renderReadField";

export const ConfirmacionTraslado = (props) => {
    const {
        movimientoSeleccionado,
        onClose,
        almacenOrigen,
        almacenDestino,
        onSuccess,
    } = props;

    const { crearInventario, trasladarMovimiento, cargando } =
        CreacionTrasladoAlmacenApi();

    const TrasladarMovimiento = async () => {
        try {
            const data = {
                movimiento_id: movimientoSeleccionado.movimiento_id,
                almacen_destino_id: almacenDestino.id,
            };

            await trasladarMovimiento(data);

            NotificationManager.success(
                "Traslado creado correctamente",
                "Éxito",
                3000,
            );

            onClose();
            onSuccess();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al crear traslado",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    if (!movimientoSeleccionado) return null;

    return (
        <Modal
            open={!!movimientoSeleccionado}
            onClose={onClose}
            closeOnOverlayClick={!cargando}
            focusTrapped={false}
            // aumentar width con style
            styles={{
                modal: {
                    maxWidth: "900px",
                    width: "90%",
                },
            }}
        >
            <LoadMask loading={cargando} blur>
                <h5 className="text-center">Confirmar traslado</h5>

                <DatosAlmacen
                    datosAlmacen={almacenOrigen}
                    almacenSeleccionado={almacenDestino}
                />

                <h6>Recepción seleccionada</h6>

                <div className="new-table-wrapper creacion-traslado-almacen__table-wrapper">
                    <table className="table-striped">
                        <thead>
                            <tr>
                                <th>ID RECEPCIÓN</th>
                                <th>FECHA INGRESO</th>
                                <th>KILOS HÚMEDOS</th>
                                <th>DRC LABORATORIO</th>
                                <th>KILOS SECOS LAB</th>
                                <th>DRC LIQUIDACIÓN</th>
                                <th>KILOS SECOS LIQ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={movimientoSeleccionado.movimiento_id}>
                                <td className="text-center text-nowrap">
                                    {movimientoSeleccionado.display_id}
                                </td>
                                <td className="text-center text-nowrap">
                                    {movimientoSeleccionado.fecha_ingreso
                                        ? moment(
                                              movimientoSeleccionado.fecha_ingreso,
                                          ).format("DD/MM/YYYY HH:mm")
                                        : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={
                                            movimientoSeleccionado.kg_humedos
                                        }
                                    >
                                        <RenderKilogramo
                                            value={
                                                movimientoSeleccionado.kg_humedos
                                            }
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={movimientoSeleccionado.drc_lab}
                                    >
                                        <RenderNumberPercentage
                                            value={
                                                movimientoSeleccionado.drc_lab
                                            }
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={
                                            movimientoSeleccionado.kg_secos_lab
                                        }
                                    >
                                        <RenderKilogramo
                                            value={
                                                movimientoSeleccionado.kg_secos_lab
                                            }
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={movimientoSeleccionado.drc_liq}
                                    >
                                        <RenderNumberPercentage
                                            value={
                                                movimientoSeleccionado.drc_liq
                                            }
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={
                                            movimientoSeleccionado.kg_secos_liq
                                        }
                                    >
                                        <RenderKilogramo
                                            value={
                                                movimientoSeleccionado.kg_secos_liq
                                            }
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="d-flex flex-wrap justify-content-center mt-4 mb-2 gap-1rem">
                    <button
                        className="btn btn-outline-dark"
                        onClick={onClose}
                        disabled={cargando}
                    >
                        Regresar
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={TrasladarMovimiento}
                    >
                        Confirmar traslado
                    </button>
                </div>
            </LoadMask>
        </Modal>
    );
};
